import React, { useEffect, useState } from 'react'
import DOMPurify from 'dompurify'
import { YOUR_REPORTS_TABS } from '../common/institutionalConstants.js'
import {
  reportOrderIndex,
  getBREDocumentData,
} from '../common/institutionalServiceHelper.js'

export default function YourReportsAccordionSection({
  reportsData,
  userPreferances,
  downloadDocs,
  updateUserPreferances,
}) {
  const [tabs, setTabs] = useState([])
  const [activeTab, setActiveTab] = useState('')
  const [reportsContent, setReportsContent] = useState({})
  const [accordionState, setAccordionState] = useState({})
  const hasData = (payload) => Array.isArray(payload) && payload?.length > 0
  const initTab = () => {
    const _tabs = []
    const hasRecentReports = hasData(reportsData?.recentReports)
    const hasArchiveReports = hasData(reportsData?.archiveReports)
    if (hasRecentReports) {
      _tabs.push(YOUR_REPORTS_TABS[0])
    }
    if (hasArchiveReports) {
      _tabs.push(YOUR_REPORTS_TABS[1])
    }
    setTabs(_tabs)
    if (_tabs?.length > 0) {
      setActiveTab(_tabs[0])
    }

    const _accordionState = {}
    _tabs.forEach((tab) => {
      _accordionState[tab?.name] = {}
      reportsData[tab?.name].forEach((report) => {
        const reportName = `${tab?.userPreferance}_${report?.reportTypeCode}`
        _accordionState[tab?.name][reportName] =
          userPreferances?.length > 0 && userPreferances.includes(reportName)
      })
    })
    setAccordionState(_accordionState)
  }

  useEffect(() => {
    initTab()
    getBREReportTabData()
  }, [reportsData])

  const filterReportDateWise = (payload) => {
    if (payload == null || payload == undefined) {
      return []
    }
    const data = payload?.reduce(
      (p, n) => ({ ...p, [n.reportDate]: [...(p[n.reportDate] ?? []), n] }),
      {}
    )
    const finalData = Object.keys(data).map((itx) => data[itx])
    return finalData
  }

  const sortReport = (a, b) => {
    const ai = reportOrderIndex.has(a?.reportTypeCode)
      ? reportOrderIndex.get(a?.reportTypeCode)
      : Number.POSITIVE_INFINITY
    const bi = reportOrderIndex.has(b?.reportTypeCode)
      ? reportOrderIndex.get(b?.reportTypeCode)
      : Number.POSITIVE_INFINITY
    return ai - bi
  }

  const getBREReportTabData = async () => {
    const recentData = await getBREDocumentData('login/recent-reports')
    const archivedData = await getBREDocumentData('login/archived-reports')
    const formateData = (data) => ({
      content: data[0]?.html?.content,
    })
    setReportsContent({
      recentReports: formateData(recentData),
      archiveReports: formateData(archivedData),
    })
  }

  const toggleAccordionState = (tabName, reportName) => {
    const _accordionState = { ...accordionState }
    _accordionState[tabName] = { ...accordionState[tabName] }
    if (typeof reportName === 'boolean') {
      const allReports = Object.keys(_accordionState[tabName])
      allReports.forEach((report) => {
        _accordionState[tabName][report] = reportName
      })
    } else {
      _accordionState[tabName][reportName] =
        !_accordionState[tabName][reportName]
    }

    setAccordionState(_accordionState)
  }

  const isOpenAllAccordion = () => {
    const activeAccordion = accordionState[activeTab?.name]
    const allReports = Object.values(activeAccordion)
    return allReports?.some((i) => i === true)
  }

  return tabs?.length < 1 ? null : (
    <div>
      <ul className="List List--inline List--selectable u-flexJustifyStart u-borderBottom">
        {tabs.map((tbx) => (
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions -- CTINEXT-4710
          <li
            onClick={() => setActiveTab(tbx)}
            key={tbx.name}
            data-analytics={tbx.name}
            className={`${tbx.name === activeTab?.name ? 'is-selected' : ''} List-item u-textSizeMsrp1 u-paddingHoriz5gu u-paddingVert3gu u-marginLeftM2gu`}
          >
            {tbx.displayValue}
          </li>
        ))}
      </ul>
      <div
        className="Content u-paddingTop3gu u-paddingBottom8gu u-textSizeMsrm1"
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(
            reportsContent[activeTab?.name] &&
              reportsContent[activeTab?.name]?.content
          ),
        }}
      ></div>
      <div className="Accordion Accordion--ruled Content">
        <div className="u-paddingRight2gu u-textRight u-paddingBottom4gu">
          {isOpenAllAccordion() ? (
            <button
              className="Link u-textNormal u-textSizeMsrm1"
              onClick={() => toggleAccordionState(activeTab?.name, false)}
            >
              Collapse all reports
            </button>
          ) : (
            <button
              className="Link u-textNormal u-textSizeMsrm1"
              onClick={() => toggleAccordionState(activeTab?.name, true)}
            >
              Expand all reports
            </button>
          )}
        </div>
        {reportsData[activeTab?.name]
          ?.filter((i) => i?.reports?.length > 0)
          ?.sort(sortReport)
          ?.map((acc, index) => {
            const reportName = `${activeTab?.userPreferance}_${acc?.reportTypeCode}`
            const filterData = filterReportDateWise(acc?.reports)
            return (
              <AccordionSection
                {...{
                  key: reportName,
                  reportIndex: index,
                  reportName,
                  reportType: acc?.reportTypeCode,
                  filterData,
                  downloadDocs,
                  updateUserPreferances,
                  accordionState,
                  toggleAccordionState,
                  tabName: activeTab?.name,
                }}
              />
            )
          })}
      </div>
    </div>
  )
}

const AccordionSection = ({
  reportIndex,
  reportType,
  filterData,
  reportName,
  downloadDocs,
  updateUserPreferances,
  accordionState,
  toggleAccordionState,
  tabName,
}) => {
  const isOpen = accordionState[tabName][reportName]
  const toggleAccordion = () => {
    updateUserPreferances(!isOpen, reportName)
    toggleAccordionState(tabName, reportName)
  }

  return (
    <div
      key={reportName}
      className={`Accordion-item u-borderColorNeutralLight ${reportIndex === 0 ? 'u-borderTop' : ''}`}
      open={isOpen}
    >
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- CTINEXT-4710 */}
      <div
        className="Accordion-toggle Accordion-toggle2"
        onClick={() => toggleAccordion()}
      >
        <div className="u-flexGrow1">{reportType} Reports</div>
        <div className="u-textSizeMsrm1 u-textNormal u-paddingRight2gu">
          {isOpen ? 'Collapse' : 'Expand'} {reportType?.toLowerCase()} reports
        </div>
      </div>
      {isOpen && (
        <>
          <div className=" u-bgColorPaleBlue u-textSizeMsrm1 u-flex u-paddingVert3gu u-textBold u-borderBottom u-borderColorNeutralLight">
            <div className="u-flexGrow1 u-paddingHoriz4gu">Date</div>
            <div className="u-flexGrow1 u-paddingHoriz4gu">Title</div>
            <div className="u-flexGrow1 u-paddingHoriz4gu">Format / Size</div>
            <div className="u-flexGrow1 u-paddingHoriz4gu">Action</div>
          </div>
          {filterData?.map((itx, idxmain) => (
            <details
              key={itx[0]?.reportDate}
              className={`Accordion-item ${filterData?.length - 1 === idxmain ? 'u-borderBottom0' : ''}`}
            >
              <summary className="Accordion-toggle Accordion-toggle2 u-bgColorSlateLight u-textSizeMsrm1 u-textNormal">
                <div className="u-flexGrow1">{itx[0]?.reportDate}</div>
                <div className="u-flexGrow1 u-paddingHoriz4gu">-</div>
                <div className="u-flexGrow1 u-paddingHoriz4gu">ZIP</div>
                <div className="u-flexGrow1 u-paddingHoriz4gu">
                  <button
                    className="Link u-textNormal"
                    onClick={() => downloadDocs(itx)}
                  >
                    Download All
                  </button>
                </div>
              </summary>
              {itx?.map((report, idx) => (
                <div
                  key={itx[0]?.reportDate + '-' + idx}
                  className="u-flex u-paddingVert3gu u-borderTop u-textSizeMsrm1 u-textDefault u-borderColorNeutralLight"
                >
                  <div className="u-flexGrow1 u-paddingHoriz4gu"></div>
                  <div className="u-flexGrow1 u-paddingHoriz4gu">
                    <button
                      className="Link u-textNormal"
                      onClick={() => downloadDocs(report?.reportId)}
                    >
                      {report?.reportTitle}
                    </button>
                  </div>
                  <div className=" u-flexGrow1 u-paddingHoriz4gu">
                    {report?.reportFormatTypeCode}({report?.reportSize}kb)
                  </div>
                  <div className=" u-flexGrow1 u-paddingHoriz4gu">
                    <button
                      className="Link u-textNormal"
                      onClick={() => downloadDocs(report?.reportId)}
                    >
                      Download
                    </button>
                  </div>
                </div>
              ))}
            </details>
          ))}
        </>
      )}
    </div>
  )
}
